import { SpinnerButton as WalrusSpinnerButton, style } from '@do/walrus';
import styled from 'styled-components';
import newBrandDesignVars from './overwrite-vars.scss';

const NewSpinnerButton = styled(WalrusSpinnerButton)`
  margin-top: ${style.vars.whitespace.medium};
  border-radius: ${newBrandDesignVars.border_radius_xlarge};
`;

export default NewSpinnerButton;
